"use client";

import React from "react";

type TabType = "sales" | "customers" | "review";

interface DashboardTabsProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

const TABS: { key: TabType; label: string }[] = [
  { key: "sales", label: "Sales" },
  { key: "customers", label: "Customers" },
  { key: "review", label: "Review" },
];

export const DashboardTabs: React.FC<DashboardTabsProps> = ({
  activeTab,
  onTabChange,
}) => {
  const activeIndex = TABS.findIndex((tab) => tab.key === activeTab);

  return (
    <div className="relative flex">
      {TABS.map((tab) => (
        <button
          className={`flex-1 py-1.5 text-sm font-medium text-center transition-colors relative ${
            activeTab === tab.key
              ? "text-gray-900 dark:text-white"
              : "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
          }`}
          key={tab.key}
          onClick={() => onTabChange(tab.key)}
          type="button"
        >
          {tab.label}
        </button>
      ))}
      <span
        className="absolute -bottom-1 h-1 bg-primary rounded-full transition-all duration-300 ease-in-out"
        style={{
          width: `${100 / TABS.length}%`,
          left: `${(activeIndex * 100) / TABS.length}%`,
        }}
      />
    </div>
  );
};
